import {
  format,
  formatDistanceToNowStrict,
  isToday,
  isYesterday,
} from 'date-fns';
import {
  Bell,
  CreditCard,
  FileText,
  Handshake,
  PackageSearch,
  ShieldCheck,
  ShoppingCart,
  Store,
  Undo2,
  UserPlus,
  Users,
  Wallet,
} from 'lucide-react';

export const CATEGORY_META = {
  quotes: { label: 'Quotes', icon: FileText, color: '#1b3b5f', bg: '#EAF0F6' },
  bargains: { label: 'Bargains', icon: Handshake, color: '#6D28D9', bg: '#F3E8FF' },
  orders: { label: 'Orders', icon: ShoppingCart, color: '#0369A1', bg: '#E0F2FE' },
  payments: { label: 'Payments', icon: CreditCard, color: '#047857', bg: '#ECFDF5' },
  customers: { label: 'Customers', icon: UserPlus, color: '#0F766E', bg: '#CCFBF1' },
  sales_partners: { label: 'Sales partners', icon: Users, color: '#4338CA', bg: '#E0E7FF' },
  vendors: { label: 'Vendors', icon: Store, color: '#B45309', bg: '#FEF3C7' },
  payouts: { label: 'Payouts', icon: Wallet, color: '#92400E', bg: '#FDE68A' },
  returns: { label: 'Returns', icon: Undo2, color: '#B91C1C', bg: '#FEE2E2' },
  requests: { label: 'Requests', icon: PackageSearch, color: '#475569', bg: '#F1F5F9' },
  team: { label: 'Admin team', icon: ShieldCheck, color: '#1b3b5f', bg: '#EAF0F6' },
  system: { label: 'System', icon: Bell, color: '#475569', bg: '#F1F5F9' },
};

export const CATEGORY_ORDER = [
  'quotes',
  'orders',
  'payments',
  'bargains',
  'payouts',
  'returns',
  'customers',
  'sales_partners',
  'vendors',
  'requests',
  'team',
];

export const categoryMeta = (category) =>
  CATEGORY_META[category] ?? CATEGORY_META.system;

const toDate = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

export const timeAgo = (value) => {
  const date = toDate(value);
  if (!date) return '';
  if (Date.now() - date.getTime() < 45_000) return 'Just now';
  return formatDistanceToNowStrict(date, { addSuffix: true });
};

export const fullTime = (value) => {
  const date = toDate(value);
  return date ? format(date, 'd MMM yyyy, h:mm a') : '';
};

export const dayLabel = (value) => {
  const date = toDate(value);
  if (!date) return 'Earlier';
  if (isToday(date)) return 'Today';
  if (isYesterday(date)) return 'Yesterday';
  return format(date, 'EEEE, d MMM yyyy');
};

export const badgeText = (count) => (count > 99 ? '99+' : String(count));
